import React from 'react';

import ErrorBoundary from '../components/partials/ErrorBoundary';
import { ApiProvider } from './ApiContext';
import { KeysProvider } from './KeysContext';
import { LayoutProvider } from './LayoutContext';
import { QueriesProvider } from './QueriesContext';
import { SiteProvider } from './SiteContext';

import type { Page, Popup } from '../types/entities';
import type { MenuItem } from '../types/shared';

interface SiteProps {
    pages?: Record<string, Page>;
    categories?: { id: number; name?: string; type?: string }[];
    lavalPosition?: { latitude: number; longitude: number };
    newArticle?: Page | null;
    lastLocation?: string | null;
    statusCode?: number | null;
    showCookieConsent?: boolean;
}

interface LayoutProps {
    size?: { width: number; height: number };
    scroll?: { x: number; y: number };
    fontsLoaded?: boolean;
    menuOpened?: boolean;
    popupClosed?: boolean;
    footerIsPurple?: boolean;
}

interface MenusProps {
    headerTopMenu?: MenuItem[];
    headerMainMenu?: MenuItem[];
    socialMenu?: MenuItem[];
    footerMenu?: MenuItem[];
}

interface AppProvidersProps {
    children: React.ReactNode;
    site?: SiteProps | null;
    popup?: Popup | null;
    page?: Page | null;
    layout?: LayoutProps | null;
    homeSplash?: boolean | null;
    menus?: MenusProps | null;
    keys?: Record<string, string | null> | null;
}

export const AppProviders: React.FC<AppProvidersProps> = ({
    children,
    site = null,
    popup = null,
    layout = null,
    homeSplash = null,
    menus = null,
    page = null,
    keys = null,
}) => {
    return (
        <ErrorBoundary>
            <ApiProvider>
                <QueriesProvider page={page}>
                    <KeysProvider keys={keys}>
                        <SiteProvider
                            {...site}
                            menus={menus}
                            popup={popup}
                            animationComplete={!homeSplash}
                        >
                            <LayoutProvider {...layout}>{children}</LayoutProvider>
                        </SiteProvider>
                    </KeysProvider>
                </QueriesProvider>
            </ApiProvider>
        </ErrorBoundary>
    );
};

export default AppProviders;
